export function supportsStreamingOptions(model: {publisher: string}): boolean {
  return model.publisher.toLowerCase() === 'openai'
}
